import { motion } from 'framer-motion';
import { Plus, Search } from 'lucide-react';
import { useNavigate } from '@tanstack/react-router';
import { format } from 'date-fns';
import { de } from 'date-fns/locale';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/contexts/AuthContext';

function getGreeting(): string {
  const hour = new Date().getHours();
  if (hour < 12) return 'Guten Morgen';
  if (hour < 18) return 'Guten Tag';
  return 'Guten Abend';
}

function getUserName(user: { email?: string; first_name?: string } | null): string {
  if (!user) return '';
  if (user.first_name) return user.first_name;
  // Extract name from email (before @)
  if (user.email) {
    const name = user.email.split('@')[0];
    return name.charAt(0).toUpperCase() + name.slice(1);
  }
  return '';
}

export function DashboardHeader() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const greeting = getGreeting();
  const userName = getUserName(user);
  const today = format(new Date(), "EEEE, d. MMMM yyyy", { locale: de });

  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ type: 'spring', stiffness: 300, damping: 30 }}
      className="flex items-center justify-between"
    >
      {/* Left side: Greeting */}
      <div>
        <h1 className="text-2xl lg:text-3xl font-bold text-slate-900">
          {greeting},{' '}
          <span className="bg-gradient-to-r from-brand-from to-brand-to bg-clip-text text-transparent">
            {userName}
          </span>
        </h1>
        <p className="text-slate-500 mt-1 capitalize">{today}</p>
      </div>

      {/* Right side: Quick Actions */}
      <div className="flex items-center gap-3">
        <Button
          variant="outline"
          size="sm"
          className="gap-2"
          onClick={() => {
            // TODO: Implement search modal
          }}
        >
          <Search className="h-4 w-4" />
          <span className="hidden sm:inline">Suchen</span>
        </Button>
        <Button
          size="sm"
          className="gap-2 bg-gradient-to-r from-action-from to-action-to hover:from-action-hover-from hover:to-action-hover-to text-action-text"
          onClick={() => navigate({ to: '/lawyer/cases' })}
        >
          <Plus className="h-4 w-4" />
          <span className="hidden sm:inline">Neuer Fall</span>
        </Button>
      </div>
    </motion.div>
  );
}
